import React from "react";
var __jsx = React.createElement;
import Spacing from "@/_LayoutsRelated/spacing/Spacing";
import stl from "./Bulleted-list-cards.module.css";
// @ts-ignore

import BulletedListCard from "./BulletedListCard";

// ************ Types ************ //

var BulletedListCards = function BulletedListCards(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement("section", {
    className: stl.InstallmentConditionsWrapper
  }, data === null || data === void 0 ? void 0 : data.lists.map(function (list, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "installment-condition-".concat(index),
      className: stl.InstallmentConditionsCardWrapper
    }, /*#__PURE__*/React.createElement(BulletedListCard, {
      list_items: list.list_items,
      title: list.title,
      icon: list.icon
    }));
  })));
};
export default BulletedListCards;